import { GlobalCartActionKind, GlobalCartState } from './constants';

export function setGlobalCartAllState({
  entries,
  appliedVouchers,
  branch,
  strikeThroughPrice,
  subTotal,
  totalDiscounts,
  selectedEntries,
  totalCartCount,
  stampDutyFee,
  isGlobalCartPending,
}: GlobalCartState) {
  return {
    type: GlobalCartActionKind.SET_GLOBAL_CART_ALL_STATE,
    entries,
    appliedVouchers,
    branch,
    strikeThroughPrice,
    subTotal,
    totalDiscounts,
    selectedEntries,
    totalCartCount,
    stampDutyFee,
    isGlobalCartPending,
  };
}
export function setGlobalCartAllEntries(entries: GlobalCartState['entries']) {
  return {
    type: GlobalCartActionKind.SET_GLOBAL_CART_ALL_ENTRIES,
    entries: entries,
  };
}

export function setGlobalCartEntries(entries: GlobalCartState['entries']) {
  return { type: GlobalCartActionKind.SET_GLOBAL_CART_ENTRIES, entries };
}

export function setGlobalCartBranch(branch: GlobalCartState['branch']) {
  return { type: GlobalCartActionKind.SET_GLOBAL_CART_BRANCH, branch };
}

export function setGlobalCartTotalCartCount(totalCartCount: number) {
  return { type: GlobalCartActionKind.SET_GLOBAL_CART_TOTAL_COUNT, totalCartCount };
}

export function setGlobalCartSelectedEntries(selectedEntries: GlobalCartState['selectedEntries']) {
  return { type: GlobalCartActionKind.SET_GLOBAL_CART_SELECTED_ENTRIES, selectedEntries };
}

export function selectGlobalCartEntry(uuid: string) {
  return { type: GlobalCartActionKind.SELECT_GLOBAL_CART_ENTRY, uuid };
}

export function setGlobalCartCode(cartCode: string) {
  return { type: GlobalCartActionKind.SET_GLOBAL_CART_CODE, cartCode };
}
export function setGlobalCartIsGlobalCartPending(
  isGlobalCartPending: GlobalCartState['isGlobalCartPending']
) {
  return { type: GlobalCartActionKind.SET_GLOBAL_CART_IS_GLOBAL_CART_PENDING, isGlobalCartPending };
}

export function resetGlobalCartState() {
  return { type: GlobalCartActionKind.RESET_GLOBAL_CART_STATE };
}
